<template>
  <div class="app-container">
    <el-form
      :model="queryParams"
      ref="queryForm"
      size="small"
      :inline="true"
      v-show="showSearch"
      label-width="114px"
    >
      <!-- <el-form-item label="手机号" prop="phone">
        <el-input
          v-model="queryParams.phone"
          placeholder=" 手机号"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item> -->
      <el-form-item label="用户" prop="userId">
        <el-select
          v-model="queryParams.userId"
          placeholder="请选择用户"
          clearable
          filterable
        >
          <el-option
            v-for="(item, index) in userList"
            :key="index"
            :label="item.userName"
            :value="item.userId"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select
          v-model="queryParams.status"
          placeholder="请选择状态"
          clearable
          filterable
        >
          <el-option
            v-for="(item, index) in statusList"
            :key="index"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="下单时间" prop="createTime">
        <el-date-picker
          clearable
          v-model="queryParams.createTime"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="请选择下单时间"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          icon="el-icon-search"
          size="mini"
          @click="handleQuery"
          >搜索</el-button
        >
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery"
          >重置</el-button
        >
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <!-- <el-col :span="1.5">
        <el-button
          type="warning"
          plain
          icon="el-icon-download"
          size="mini"
          @click="handleExport"
          >导出</el-button
        >
      </el-col> -->
      <right-toolbar
        :showSearch.sync="showSearch"
        @queryTable="getList"
      ></right-toolbar>
    </el-row>

    <el-table v-loading="loading" :data="orderList">
      <el-table-column
        label="订单id"
        align="center"
        prop="id"
        show-overflow-tooltip
      />
      <el-table-column
        label="店铺名称"
        align="center"
        prop="storeName"
        show-overflow-tooltip
      />
      <el-table-column
        label="用户名称"
        align="center"
        prop="userName"
        show-overflow-tooltip
      />
      <el-table-column
        label="总积分"
        align="center"
        prop="totalMoney"
        show-overflow-tooltip
      />
      <el-table-column
        label="订单状态"
        align="center"
        prop="statusName"
        show-overflow-tooltip
      />
      <el-table-column
        label="下单时间"
        align="center"
        prop="createTime"
        show-overflow-tooltip
      />
      <el-table-column
        label="操作"
        align="center"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <!-- 详情是这一条的详情，订单详情是订单的详情 -->
          <!-- 订单详情 -->
          <el-button
            size="mini"
            type="text"
            icon="el-icon-search"
            @click="handlesee(scope.row)"
            >订单详情</el-button
          >
          <!-- 接单 -->
          <el-button
            v-if="scope.row.status == '1'"
            size="mini"
            type="text"
            icon="el-icon-thumb"
            @click="handleJiedan(scope.row)"
            >接单</el-button
          >
          <!-- 结算 -->
          <!-- <el-button
            v-if="scope.row.status == '5'"
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="handleChecking(scope.row)"
            >结算</el-button
          > -->
          <el-button
            size="mini"
            type="text"
            icon="el-icon-delete"
            @click="handleDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getList"
    />

    <!-- 添加或修改订单对话框 -->
    <el-drawer :title="title" :visible.sync="open" size="45%" append-to-body>
      <!--点击空白处不关闭 :wrapperClosable="false" -->
      <el-form
        class="forms"
        ref="form"
        :model="form"
        label-width="120px"
        :disabled="title == '详情'"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="店铺名称" prop="storeName">
              <el-input v-model="form.storeName" placeholder=" 店铺名称" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="用户名称" prop="userName">
              <el-input v-model="form.userName" placeholder=" 用户名称" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="总金额" prop="totalMoney">
              <el-input v-model="form.totalMoney" placeholder=" 总金额" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="订单状态" prop="statusName">
              <el-input v-model="form.statusName" placeholder="订单状态" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="订单备注" prop="remark">
              <el-input
                style="width: 96%"
                type="textarea"
                v-model="form.remark"
                placeholder="订单备注"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-form
        class="forms"
        ref="goodsForm"
        :model="goodsForm"
        label-width="120px"
        :disabled="title == '详情'"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="商品图片" prop="Img">
              <ImagePreview
                style="margin-right: 10px"
                v-for="(item, index) in Img"
                :key="index"
                :src="item"
                :width="60"
                :height="60"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商品名称" prop="goodsName">
              <el-input v-model="goodsForm.goodsName" placeholder=" 商品名称" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商品单价" prop="buyIntegral">
              <el-input
                v-model="goodsForm.buyIntegral"
                placeholder=" 商品单价"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="购买数量" prop="buyNumber">
              <el-input v-model="goodsForm.buyNumber" placeholder=" 购买数量" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="下单时间" prop="createTime">
              <el-input v-model="form.createTime" placeholder=" 下单时间" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <!-- <div class="demo-drawer__footer">
        <el-button @click="cancel">关 闭</el-button>
      </div> -->
    </el-drawer>
  </div>
</template>

<script>
import {
  listOrder,
  delOrder,
  addOrder,
  updateOrder,
  settlement,
  getOrderUserName,
} from "@/api/order";

export default {
  name: "Order",
  data() {
    return {
      statusList: [
        {
          id: 0,
          name: "全部",
        },
        {
          id: 1,
          name: "已下单",
        },
        {
          id: 2,
          name: "待取货",
        },
        {
          id: 3,
          name: "已完成",
        },
        {
          id: 4,
          name: "已取消",
        },
      ],
      goodsForm: {},
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 订单表格数据
      orderList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        platformId: this.$route.query.platformId,
        status: 0,
        storeId: this.$route.query.storeId,
        createTime: null,
        userId: null,
        phone: null,
      },
      // 表单参数
      form: {
        id: null,
        storeId: null,
        userId: null,
        userName: null,
        phone: null,
        goodsAmount: null,
        totalMoney: null,
        payMoney: null,
        payDeposit: null,
        returnDeposit: null,
        discountMoney: null,
        memberMoney: null,
        ticketSn: null,
        ticketMemo: null,
        payTime: null,
        lendTime: null,
        agreeOnTime: null,
        realityTime: null,
        status: null,
        createTime: null,
        updateTime: null,
      },
      Img: [],
      userList: [],
    };
  },
  created() {
    this.getList();
    this.getOrderUserName();
  },
  methods: {
    // 获取用户下拉框
    getOrderUserName() {
      getOrderUserName({
        platformId: this.$route.query.platformId,
        storeId: this.$route.query.storeId,
      }).then((res) => {
        if (res.code == 200) {
          this.userList = res.data;
        }
      });
    },
    /** 查询订单列表 */
    getList() {
      this.loading = true;
      listOrder(this.queryParams).then((response) => {
        this.orderList = response.data.list;
        this.total = response.data.total;
        this.loading = false;
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    resetForm(refName) {
      if (this.$refs[refName]) {
        this.$refs[refName].resetFields();
      }
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        storeId: null,
        userId: null,
        phone: null,
        goodsAmount: null,
        totalMoney: null,
        payMoney: null,
        payDeposit: null,
        returnDeposit: null,
        discountMoney: null,
        memberMoney: null,
        ticketSn: null,
        ticketMemo: null,
        payTime: null,
        lendTime: null,
        agreeOnTime: null,
        realityTime: null,
        status: null,
        createTime: null,
        updateTime: null,
      };
      this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },

    /** 详情按钮操作 */
    handlesee(row) {
      this.reset();
      this.form = Object.assign({}, row);
      this.goodsForm = row.detail[0];
      this.Img = this.goodsForm.goodsImg.split(",");
      this.open = true;
      this.title = "详情";
    },
    // 接单
    handleJiedan(row) {
      const h = this.$createElement;
      this.$confirm("提示", {
        title: "提示",
        message: h("div", [
          h("p", "确定要接取该订单吗?"),
          h("p", "提示:接单前请确认该商品库存数量"),
        ]),
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          updateOrder({
            id: row.id,
            status: 2,
          }).then((response) => {
            this.$message({
              message: "接单成功",
              type: "success",
            });
            this.open = false;
            this.getList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    // 结算
    handleChecking(row) {
      // console.log(row.id, "id");
      settlement(row.id).then((res) => {
        // console.log("结算", res);
        this.$modal.msgSuccess("结算成功");
        this.getList();
      });
      // console.log("结算");
    },

    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (this.form.id != null) {
            updateOrder(this.form).then((response) => {
              this.$modal.msgSuccess("修改成功");
              this.open = false;
              this.getList();
            });
          } else {
            addOrder(this.form).then((response) => {
              this.$modal.msgSuccess("新增成功");
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const ids = row.id || this.ids;
      this.$modal;
      this.$confirm("是否确认删除该订单？", {
        type: "warning",
      })
        .then(function () {
          return delOrder({ id: ids });
        })
        .then(() => {
          this.getList();
          this.$message({
            message: "删除成功",
            type: "success",
          });
        })
        .catch(() => {});
    },
    /** 导出按钮操作 */
    handleExport() {
      this.download(
        "system/order/export",
        {
          ...this.queryParams,
        },
        `order_${new Date().getTime()}.xlsx`
      );
    },
  },
};
</script>
<style scoped>
/deep/ .el-collapse-item__header {
  font-size: 16px !important;
}
</style>
